import get from "lodash.get";
import { useMemo, useState } from "react";

import * as Client from "api/client";
import { useAuth } from "providers/Auth";
import { useShop } from "providers/Shop";
import Context from "./Context";

import { handleDeliveryUri, handleEnabledRefund } from "./method";

import { VARIABLES } from "config/const";
import { APPRECIATION_PERIOD_PATH } from "utils/shop-settings";

const annotations = {
  remit_account: {
    type: "STRING",
    label: "帳號後5碼",
    prerequisities: { payment_flow: ["ATM"] },
  },
  address: {
    type: "STRING",
    label: "Address",
    prerequisities: {
      delivery_flow: ["SEVEN", "FAMILY", "HOME", "STORE"],
    },
  },
};

const getOrderAnnotationFns = (order) => {
  const findAnnotationitems = () =>
    order.annotations.filter(
      (annotation) => (annotation.key.split("_")[1] || "").length === 36
    ) || [];
  const findExtendItems = (prerequisiteKey, prerequisiteValue) => {
    return Object.entries(annotations).reduce((arr, [key, value]) => {
      if (
        (value.prerequisities[prerequisiteKey] || []).includes(
          prerequisiteValue
        )
      ) {
        arr[key] = value;
      }
      return arr;
    }, {});
  };

  return {
    findAnnotationitems,
    findExtendItems,
  };
};

const Provider = ({ children }) => {
  const [order, setOrder] = useState({});
  const [orders, setOrders] = useState([]);

  const { shop } = useShop();
  const { auth } = useAuth();
  const { userId, idToken } = auth;

  const getOrder = (id) =>
    Client.getOrder(userId, id, idToken).then((res) => {
      if (!res.err) {
        setOrder(res);
        return true;
      } else {
        return false;
      }
    });

  const handleOrders = async (orders) => {
    const paymentLinkMap = {};
    const appreciationPeriodDay = get(shop, APPRECIATION_PERIOD_PATH, 0);

    const getPaymentLinks = orders
      .filter((order) => order.PAYMENT_STATUS === "未付款")
      .map((order) =>
        getPaymentLink(order.ID).then(
          (res) => (paymentLinkMap[order.ID] = res.uri)
        )
      );

    orders = handleDeliveryUri(orders);
    orders = handleEnabledRefund(orders, appreciationPeriodDay);
    if (getPaymentLinks.length) {
      await Promise.allSettled(getPaymentLinks);
      orders.forEach((order) => {
        if (paymentLinkMap[order.ID]) {
          order.paymentUri = paymentLinkMap[order.ID];
        }
      });
    }

    //TODO: i18n
    Array.from(orders).forEach((order) => {
      console.log("order");
      console.log(order);
      Object.keys(order).forEach((key) => {
        if (VARIABLES[key]) {
          let keyValue = Array.from(VARIABLES[key]).find((v) =>
            String(order[key]).includes(v.value)
          );
          if (keyValue) {
            order[key] = String(keyValue.key).toLocaleLowerCase();
          }
        }
      });
    });

    return orders;
  };

  const getPaymentLink = (orderId) =>
    Client.getPaymentLink(userId, idToken, orderId).then((res) => {
      if (!res.err) {
        return res;
      } else {
        return false;
      }
    });

  const getOrders = () =>
    Client.getOrders(userId, idToken).then(async (res) => {
      if (!res.err) {
        const orders = await handleOrders(res);
        setOrders(orders);
        return true;
      } else {
        return false;
      }
    });

  const cancelOrder = (orderId) =>
    Client.cancelOrder(userId, orderId, idToken).then((res) => {
      if (!res.err) {
        const newOrders = orders.map((order) => {
          if (order.ID === orderId) order.STATUS = "cancel";
          return order;
        });
        setOrders(newOrders);
        return true;
      } else {
        return false;
      }
    });

  const { findAnnotationitems, findExtendItems } = useMemo(
    () => getOrderAnnotationFns(order),
    [order]
  );

  const props = {
    order,
    orders,
    getOrders,
    getOrder,
    cancelOrder,
    findAnnotationitems,
    getOrderAnnotationFns,
    findExtendItems,
  };

  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
